export const REQUEST_POST_FORGEROCK = 'REQUEST_POST_FORGEROCK';
export const RECEIVE_POST_FORGEROCK = 'RECEIVE_POST_FORGEROCK';
export const REQUEST_POST_FORGEROCK_ERROR = 'REQUEST_POST_FORGEROCK_ERROR';
